import { FC, useEffect, useState } from "react";

import {
  useGetUSDKycUrlMutation,
  useGetUserQuery,
} from "../../../store/services/user";
import { useSelector } from "react-redux";
import { selectCurrentUser } from "../../../store/reducers/user";
import { Button, Icon } from "../../common";

export const UsdKycForm: FC = () => {
  const [showKycIframe, setShowKycIframe] = useState(false);
  const [getKycTokens, { data, reset }] = useGetUSDKycUrlMutation();
  const { usd_tos_accepted } = useSelector(selectCurrentUser);
  const { refetch } = useGetUserQuery();

  useEffect(() => {
    if (!data) {
      getKycTokens();
    }
  }, [data, getKycTokens]);

  useEffect(() => {
    if (usd_tos_accepted) {
      setShowKycIframe(true);
    }
  }, [usd_tos_accepted, setShowKycIframe]);

  useEffect(() => {
    // Reset request on unmount to get new token on each mount (like clear cache)
    return () => reset();
  }, [reset]);

  if (!data?.usd_kyc_url) {
    return <>Fetching USD KYC Data</>;
  }

  const tosUrl = data?.usd_tos_url;

  const baseKycUrl = data?.usd_kyc_url.replace("/verify", "/widget");
  const kycUrl = `${baseKycUrl}&iframe-origin=${encodeURIComponent(window.location.origin)}`;

  if (showKycIframe) {
    return (
      <iframe
        title="USD KYC"
        src={kycUrl}
        height={600}
        allow="camera"
        sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-modals allow-top-navigation-by-user-activation"
      />
    );
  } else {
    return (
      <>
        <iframe title="USD ToS" src={tosUrl} height={350} />
        <div className="flex justify-center">
          <Button onClick={refetch} variant={Button.variant.PRIMARY}>
            <Icon
              icon="Arrow-right"
              size={24}
              className="text-white"
              disableFill
            />{" "}
            Continue
          </Button>
        </div>
      </>
    );
  }
};
